import Axios, { AxiosRequestConfig } from 'axios';
import * as turf from '@turf/turf';
import { Field, Zone, SoilProfileSet } from '../types/types';
import { getBearerToken, queryStringFromObject } from '../utils/misc';
import { queryDwPctCloudCover } from '../utils/dwHelpers';
import { createPolygonFeatureFromZones } from '../utils/mapUtils';
import { useStore } from '../providers/AppProvider';
import { Definition } from "../../../data/Definition";
import { useState } from 'react';
import { isObject } from 'lodash';
const API_URL = process.env.REACT_APP_LS_API_URL;

const authRequestInterceptor = (config: AxiosRequestConfig) => {
    config.headers!.authorization = getBearerToken();
    config.headers!.Accept = 'application/json';

  return config;
}

export const apiClient = Axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(authRequestInterceptor);
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;
    console.error(message);
    return Promise.reject(error);
  }
);

const userInfo = async () : Promise<any> => {
  const whoami = await apiClient.get<any>(`/auth/userjwt/whoami`);
  return whoami;
}

export let dataCloudCover: any[] = [];

const allFields = async (
  definition: Definition,
  definitionField: Definition
): Promise<Field[]> => {
    const queryParams = {
      orderBy: "name",
    }
    //const { state, orgId } = useStore();
    //let definition = /*state.*/definitions.find((d: Definition) => d.name.toLowerCase().includes('plant'));
    //let definitionField = /*state.*/definitions.find((d: Definition) => d.name.toLowerCase().includes('field'));
    
    dataCloudCover = await queryDwPctCloudCover(
      //definition as Definition, 
      definitionField as Definition
    );

    const { data } = await apiClient.get<any[]>(`/landscan/data/fields?${queryStringFromObject(queryParams)}`);
    //console.log("071925 dataCloudCover", dataCloudCover);
    const fields = data.map((f: any) => {

      //console.log("071725 f", f);
      //console.log("071725 dataCloudCover", dataCloudCover);
      /*const cloudCoverFeature = dataCloudCover.find(
        (feature: any) => feature.field_id === f.entityId
      );*/
      const cloudCoverFeature = dataCloudCover ? dataCloudCover[f.entityId] || null : null;
      //console.log("072025 cloudCoverFeature", cloudCoverFeature);
      // Transform Percent Cloud_time and Percent Cloud_value into a date-keyed object
      let cloudCoverByDate: Record<string, string | undefined> = {};
      if (cloudCoverFeature && cloudCoverFeature["Percent Cloud_time"]) {
        const times = Array.isArray(cloudCoverFeature["Percent Cloud_time"])
          ? cloudCoverFeature["Percent Cloud_time"]
          : [cloudCoverFeature["Percent Cloud_time"]];
        const values = Array.isArray(cloudCoverFeature["Percent Cloud_value"])
          ? cloudCoverFeature["Percent Cloud_value"]
          : [cloudCoverFeature["Percent Cloud_value"]];
        times.forEach((dt: string, idx: number) => {
          const date = dt.split("T")[0];
          cloudCoverByDate[date] = values[idx];
        });
        //cloudCoverFeature["Percent Cloud_by_date"] = cloudCoverByDate;
      }
      //console.log("072025 cloudCoverByDate", cloudCoverByDate);
      return {
        id: f.fieldId,
        entityId: f.entityId,
        name: f.name,
        description: f.description,
        grower_id: f.growerId,
        farm_id: f.farmId,
        crop_id: f.cropId,
        variety_id: f.varietyId,
        plant_spacing: f.plantSpacing,
        plant_spacing_unit_abbrev: f.plantSpacingUnitAbbrev,
        row_spacing: f.rowSpacing,
        row_spacing_unit_abbrev: f.rowSpacingUnitAbbrev,
        year_planted: f.yearPlanted,
        enable_level_2: f.enableLevel2,
        enable_level_3: f.enableLevel3,
        calc_area: f.acres,
        area: f.area ?? f.acres,
        area_unit_abbrev: f.areaUnitAbbrev,
        url: f.url,
        geom: JSON.parse(f.geom),
        centroid: turf.centroid(JSON.parse(f.geom)),
        stats: {},
        cloud_cover: cloudCoverByDate
      } as Field;
    });

    return fields;
}

const allZones = async (fieldId: number) : Promise<Zone[]> => {
    const queryParams = {
      orderBy: "name",
    }

    const { data } = await apiClient.get<any[]>(`landscan/data/zonesets?fieldId=${fieldId}`);//${queryStringFromObject(queryParams)}`);
    console.log("B041924 data", data);
    const zonesFiltered = data.filter((f: any) => {
      if (f.zones){
        return f;
      }
    })
    console.log("B041924 zonesFiltered", zonesFiltered);
    const zonesJob = zonesFiltered.map((f: any) => {
      //console.log("041924 f", f);
      return {
        zonesetId: f.zonesetId,
        fieldId: f.fieldId,
        entityId: f.entityId,
        name: f.name,
        description: f.description,
        zonetypeId: f.zonetypeId,
        orgId: f.orgId,
        zones: f.zones,
        s3Uri: f.s3Uri,
        createdAt: f.createdAt,
        updatedAt: f.updatedAt,
        geojson: createPolygonFeatureFromZones(f.zones),
      } as Zone;
    });
    console.log("B041924 zonesJob", zonesJob);
    return zonesJob;
}

const allZonesPrelim = async (fieldId: number) : Promise<Zone[]> => {

    const { data } = await apiClient.get<any[]>(`landscan/data/zoneSetsPrelim?fieldId=${fieldId}`);//${queryStringFromObject(queryParams)}`);
    console.log("PRELIM 041924 data", data);
    const zonesJob = data.map((f: any) => {
      //console.log("PRELIM 041924 f", f);
      return {
        zonesetId: f.zonesetId,
        fieldId: f.fieldId,
        entityId: f.entityId,
        name: f.name,
        description: f.description,
        zonetypeId: f.zonetypeId,
        orgId: f.orgId,
        zones: f.zones,
        createdAt: f.createdAt,
        updatedAt: f.updatedAt,
        geojson: f.geojson, //createPolygonFeatureFromZones(f.zones),
      } as Zone;
    });
    console.log("PRELIM 041924 zonesJob", zonesJob);
    return zonesJob;
}

const pollZoneCreationStatus = async (jobId: number) : Promise<any> => {
    //const data  = await apiClient.get<any[]>(`landscan/jobs/${jobId}`);
    const data  = await apiClient.get<any[]>(`landscan/jobs/watch?topJobId=${jobId}&failStatusOnFailedChildren=true`);
    //console.log("040524 data", data);
    return data;
}

const createZoneSetPrelim = async (params: any): Promise<any> => {
  try {
    console.log("B042224 params", params);
    console.log("B042224 queryStringFromObject(params)", queryStringFromObject(params));
    const data = await apiClient.post<any[]>(`landscan/data/zonesetsPrelim`,
      queryStringFromObject(params)
    );
    console.log("040124 data", data);
    return data;
  } catch (error) {
    console.error("Error in createZoneSetPrelim:", error);
    if (isObject(error)) {
      const err: any = { ...error };
      if (err.response) {
        return err.response;
      }
    }
    
    return {};
  }
}

const unpublishZoneSet = async (zoneSetId: string ) : Promise<any> => {
    //const data = await apiClient.post<any[]>(`processing/data/zonesetsPrelim/publish`, // ?
    const data = await apiClient.post<any[]>(`/landscan/data/zoneSets/unpublish`, // or 
      {"zonesetId": zoneSetId}
    );
    console.log("040124 data", data);
    return data;
}

const publishZoneSet = async (prelimZoneSetId: string ) : Promise<any> => {
    //const data = await apiClient.post<any[]>(`processing/data/zonesetsPrelim/publish`, // ?
    const data = await apiClient.post<any[]>(`/landscan/data/zoneSetsPrelim/publish`, // or 
      JSON.stringify({"zonesetsPrelimId": prelimZoneSetId}),
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    console.log("040124 data", data);
    return data;
}

const deleteZoneSetPrelim = async (prelimZoneSetId: string ) : Promise<any> => {
    // /processing/zonesetsPrelim/{zonesetsPrelimId}
    // /landscan/data/zonesetsPrelim/{zonesetPrelimId}
    const data = await apiClient.delete<any[]>(`landscan/data/zonesetsPrelim/${prelimZoneSetId}`);
    console.log("C040624 data", data);
    return data;
}

const getFieldProfileSets = async (fieldId: number, year?: number): Promise<SoilProfileSet[]> => {
  const queryParams = {
    fieldId: fieldId,
    expandObject: true,
    dateRange: year ? `${year}-01-01/${year}-12-31` : undefined // use: `2000-01-01/${year}-12-31` to get all available years and display in 
  }

  const { data } = await apiClient.get<SoilProfileSet[]>(`/landscan/data/soilprofilesets?${queryStringFromObject(queryParams)}`);

  return data;
}

const getTextCsv = async (url: string): Promise<string> => {
  const newUrl = url.replace(API_URL!, '');

  const data = await apiClient.get(newUrl, {
    responseType: 'text'
  });

  return data.toString();
}

const LandscanService = {
    allFields,
    allZones,
    allZonesPrelim,
    createZoneSetPrelim,
    pollZoneCreationStatus,
    deleteZoneSetPrelim,
    getFieldProfileSets,
    publishZoneSet,
    unpublishZoneSet,
    getTextCsv,
    userInfo,
    apiClient
}

export default LandscanService;
